/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { OrderEdit } from '@/api/mall';
import Cons from "Constant";
export default {
  props: {
    status: {
      type: [String, Number]
    },
    orderNo: String,
    orderObj: Object
  },
  components: {},
  computed: {},
  data: function data() {
    return {};
  },
  created: function created() {},
  methods: {
    orderHandle: function orderHandle(type) {
      var _this = this;

      console.log('type' + type);
      var orderNo = this.orderNo;
      var orderObj = this.orderObj;
      var itemList = orderObj.goods;
      itemList = JSON.stringify(itemList); //1:取消订单,2:付款,3:申请退款,4:确认收货

      if (type == 3) {
        this.$emit('refundPopShow', orderNo);
      } else if (type == 1) {
        Public.dialog({
          content: '确定取消该订单？'
        }).then(function () {
          OrderEdit({
            orderNo: orderNo,
            status: 2,
            itemList: itemList
          }).then(function (data) {
            _this.$emit('orderHandleDone', 2, orderNo);
          });
        });
        ;
      } else if (type == 2) {
        //付款
        if (Cons.ENV_DEBUG) {
          this.$router.push({
            name: 'PayMallPay',
            query: {
              orderNo: orderNo,
              price: orderObj.realPrice
            }
          });
        } else {
          var appId = Utils.getSessionCache(Cons.APPID);
          var clinicId = Utils.getSessionCache(Cons.CLINIC_ID);
          window.location.href = Cons.SCRM_PATH + "pay/mallPay?orderNo=".concat(orderNo, "&price=").concat(orderObj.realPrice, "&appId=").concat(appId, "&clinicId=").concat(clinicId);
        }
      } else if (type == 4) {
        OrderEdit({
          orderNo: orderNo,
          status: 0
        }).then(function (data) {
          _this.$emit('orderHandleDone', 0, orderNo, '收货成功');
        });
      }
    }
  }
};